const buffer = new Map<any, Promise<any>>();

export function bufferPromise<T>(cacheBy: any, cb: () => Promise<T>): Promise<T> {
    if (!buffer.has(cacheBy)) {
        buffer.set(cacheBy, cb());
        buffer.get(cacheBy)!.finally(() => setTimeout(() => buffer.delete(cacheBy), 200));
    }
    return buffer.get(cacheBy)!;
}
